import React from 'react';
import { makeStyles } from '@material-ui/core';
import lodashGet from 'lodash/get';
import { useFormatMessage } from 'react-intl-hooks';
import { addCommas } from '../../../utils';
import { skins } from '../skins';
import { HistoricalTrend } from '../HistoricalTrend';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    statsContainer: {
        paddingTop: '6px',
        marginLeft: '48px',
    },
    statsRow: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '42px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    statsRowItem: {
        flex: 1,
        minWidth: '320px',
    },
    statsRowItemValue: {
        fontSize: '56px',
        lineHeight: '48px',
        fontWeight: 700,
    },
    statsRowItemLabel: {
        fontSize: '24px',
        lineHeight: '32px',
        margin: '16px auto 0 auto',
    },
    compliance: {
        position: 'absolute',
        bottom: 16,
        right: 16,
        width: '88%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '24px',
    },
    disclaimer: {
        display: 'flex',
        alignItems: 'center',
        width: '340px',
        textAlign: 'end',
    },
    disclaimerText: {
        marginRight: '16px',
    },
    copyright: {
        width: '320px',
        textAlign: 'start',
    }
}));

export default function StatsGrid(props) {
    const {
        medianDom: median_dom,
        medianDomTrend: median_dom_mm,
        medianPrice: median_price,
        medianPriceTrend: median_price_mm,
        activeListingsCount: active_listings_count,
        activeListingsCountTrend: active_listings_count_mm,
        newListingsCount: new_listings_count,
        fromMonth,
        toMonth,
        skin,
        fontFamily,
    } = props || {};
    const classes = useStyles(props);
    const t = useFormatMessage();
    const styleFontFamily = { fontFamily };

    return (
        <div className={classes.statsContainer}>
            <div className={classes.statsRow} style={styleFontFamily}>
                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {median_price}

                        <HistoricalTrend
                            value={median_price_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="large"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'median_price' }, { separator: ' ' })}}></div>

                </div>

                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${active_listings_count > 0 ? addCommas(active_listings_count) : '-'}`}

                        <HistoricalTrend
                            value={active_listings_count_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="small"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'active_listings' }, { separator: ' ' })}}></div>
                </div>

            </div>

            <div className={classes.statsRow} style={styleFontFamily}>
                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${new_listings_count > 0 ? addCommas(new_listings_count) : '-'}`}
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'new_listings' }, { separator: '<br/>' })}}></div>
                </div>
                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${median_dom > 0 ? addCommas(median_dom) : '-'}`}

                        <HistoricalTrend
                            value={median_dom_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="small"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'median_dom' }, { separator: '<br/>' })}}></div>
                </div>
            </div>

            <div className={classes.compliance} style={{ color: lodashGet(skins, `${skin}.COMPLIANCE_COLOR`) }}>
                <div className={classes.copyright}>
                    <img src={lodashGet(skins, `${skin}.LR_LOGO_PATH`)} height={16} alt="LR Logo" />
                    <div>
                        &copy; ListReports {COPYRIGHT_YEAR}, {t({ id: 'copyright' })}
                    </div>
                </div>
                <div className={classes.disclaimer}>
                    <div className={classes.disclaimerText}>{t({ id: 'disclaimer' })}</div>
                    <img src={lodashGet(skins, `${skin}.EQUAL_HOUSING_LOGO_PATH`)} height={24} alt="Equal Housing logo" />
                </div>
            </div>
        </div>
    );
}
